export const DATE_COLUMNS = [ 'date' ]
export const DATE_TIME_COLUMNS = [ 'date time', 'date & time', 'call time', 'contacted time', 'starttime', 'endtime' ]

export const DATE_FORMAT = 'DD-MM-YYYY'
export const DATE_TIME_FORMAT = 'HH:mm:ss DD-MM-YYYY'
